import { render, staticRenderFns } from "./PaymentStudents.vue?vue&type=template&id=8e0d3afa"
import script from "./PaymentStudents.vue?vue&type=script&lang=ts"
export * from "./PaymentStudents.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports